export const LEV_ASSISTANT_READY_MESSAGE = 'LEV_ASSISTANT_READY';
export const LEV_ASSISTANT_CONVERSATION_UPDATED_MESSAGE = 'LEV_ASSISTANT_CONVERSATION_UPDATED';

const FALLBACK_TARGET_ORIGIN = '*';
const PROTOCOL_VERSION = 1;

export function getParentOriginFromSearch(search: string) {
	const parentOrigin = new URLSearchParams(search).get('parentOrigin');
	if (parentOrigin == null || parentOrigin.length === 0) {
		return FALLBACK_TARGET_ORIGIN;
	}

	try {
		return new URL(parentOrigin).origin;
	} catch {
		return FALLBACK_TARGET_ORIGIN;
	}
}

export function postMessageToParent({
	type,
	payload,
	targetOrigin,
}: {
	type: string;
	payload?: unknown;
	targetOrigin: string;
}) {
	if (typeof window === 'undefined' || window.parent === window) {
		return;
	}

	window.parent.postMessage(
		{
			type,
			protocolVersion: PROTOCOL_VERSION,
			payload,
		},
		targetOrigin
	);
}
